import React, { Component } from 'react';
import { estados } from '../../util/constantsUtil';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { renderFieldNumeros, renderFieldSelect, required, requiredSelect } from '../../util/inputs';
import $ from 'jquery';
import { gerarHashForString } from '../../util/stringUtil';
import { showAlertMsg } from '../../util/messagesUtil';

export class ModalCadastrarPercursoCteOs extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            estadoSelecionado: null
        }
    }

    fecharModal() {
        $('#modalCadastrarPercursoCteOs')
            .modal('hide');
        $('#modalCadastrarPercursoCteOs')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.props.reset('formularioModalCadastroPercursoCteOS');
        this.setState({ estadoSelecionado: null });
    }

    handleChangeEstado(e) {
        this.setState({
            estadoSelecionado: e.value
        })
    }

    submit() {
        const percurso = {
            hash: gerarHashForString(`${this.state.estadoSelecionado.uf}`),
            estado: this.state.estadoSelecionado.nome,
            uf: this.state.estadoSelecionado.uf,
            ordem: this.props.ordem
        }

        if (this.props.percursoCteOS.filter(it => it.hash === percurso.hash).length > 0) {
            showAlertMsg('Já foi adicionado UF');
            return;
        }
        
        this.props.adicioanrPercursoCteOS(percurso);
        this.fecharModal();
    }

    sair(e) {
        e.preventDefault();
        this.fecharModal()
    }

    formulario() {
        const { handleSubmit, submitting, invalid } = this.props;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="vx-modal-body">
                    <div className="vx-modal-section">
                        <div className="vx-modal-section-title">
                            <i className="material-icons">route</i>
                            Dados do Percurso
                        </div>
                        <div className="form-row">
                            <div className="col-12 col-sm-6 col-md-6">
                                <Field name='estado'
                                    options={estados.map(estado => ({
                                        descricao: `${estado.nome}-${estado.uf}`,
                                        nome: estado
                                    }))}
                                    component={renderFieldSelect}
                                    label="UF"
                                    placeholder='Selecione a UF' validate={requiredSelect}
                                    onChange={(e) => this.handleChangeEstado(e)} />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-12 col-sm-6 col-md-6">
                                <Field name="ordem" type="text" validate={[required]} component={renderFieldNumeros}
                                    formatacao="####"
                                    label="Ordem:"
                                    css="form-control" readOnly={false} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="vx-modal-footer">
                    <button className="vx-btn-secondary" onClick={(e) => this.sair(e)}>
                        <i className="material-icons">close</i>
                        Sair
                    </button>
                    <button type="submit" disabled={invalid || submitting} className="vx-btn-primary">
                        <i className="material-icons">add</i>
                        Incluir
                    </button>
                </div>
            </form>
        )
    }

    render() {
        return (
            <div className="modal fade show" id='modalCadastrarPercursoCteOs' role='dialog'
                aria-labelledby='modalCadastrarPercursoCteOs' aria-hidden='true' data-backdrop='static'>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">route</i>
                                <span className="vx-modal-title">Percurso CT-e OS</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        {this.formulario()}
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        ordem: formValueSelector('formularioModalCadastroPercursoCteOS')(state, 'ordem'),
    }
}

export default connect(mapStateToProps, {
})(reduxForm({
    form: 'formularioModalCadastroPercursoCteOS'
})(ModalCadastrarPercursoCteOs));